import { apiClient } from "./api";
import { ApiResponse, OpportunityBatch, Opportunity } from "../types";

export const batchesService = {
  /**
   * Get a page of reconciliation batches
   */
  async getBatches(page = 1, pageSize = 15): Promise<ApiResponse<OpportunityBatch[]>> {
    const response = await apiClient.get<ApiResponse<OpportunityBatch[]>>("/api/batches", {
      page,
      pageSize,
    });
    return response.data;
  },

  /**
   * Get opportunities for a specific batch
   */
  async getOpportunitiesByBatch(batchName: string): Promise<ApiResponse<Opportunity[]>> {
    const response = await apiClient.get<ApiResponse<Opportunity[]>>(
      `/api/batches/${encodeURIComponent(batchName)}/opportunities`,
    );
    return response.data;
  },

  /**
   * Update batch status
   */
  async updateBatchStatus(batchName: string, status: string): Promise<ApiResponse<void>> {
    const response = await apiClient.patch<ApiResponse<void>>(
      `/api/batches/${encodeURIComponent(batchName)}/status`,
      { status },
    );
    return response.data;
  },

  /**
   * Unlock a batch: clears the Salesforce posted date and the local posting
   * snapshot so it can be posted again from fresh Salesforce data. Does not
   * reverse the original journal already posted to Sage.
   */
  async unlockBatch(batchName: string): Promise<ApiResponse<void>> {
    const response = await apiClient.post<ApiResponse<void>>(
      `/api/batches/${encodeURIComponent(batchName)}/unlock`,
    );
    return response.data;
  },
};
